var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
import * as React from "react";
import ReactTable from "react-table";
import { Button, Dimmer, Grid, Header, Input, Loader, Menu, Message, Modal, Select, Table } from "semantic-ui-react";
import FieldWithErrorDisplay from "../FieldWithErrorDisplay";
import { MetaCatalogLoader } from "../kit/Catalog";
import { RelevantCatalogType } from "../kit/automated-pro/RnaCatalog";
import { LoadWrapper } from "../kit/rna-fish/LoadWrapper";
import { CatalogMode, getWithAuthn } from "../RequestHelpers";
import { displayLocalTimestamp } from "./AllOrdersPage";
import SimpleFormWithErrorDisplay from "./SimpleFormWithErrorDisplay";
import UploadFileModal from "./UploadFileModal";
var FluorescentHairpinTrackingPage = /** @class */ (function (_super) {
    __extends(FluorescentHairpinTrackingPage, _super);
    function FluorescentHairpinTrackingPage() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    FluorescentHairpinTrackingPage.prototype.render = function () {
        var renderer = function (catalog) {
            return React.createElement(FluorescentHairpinContent, { catalog: catalog });
        };
        return React.createElement(LoadWrapper, { loader: new MetaCatalogLoader(CatalogMode.Internal, RelevantCatalogType.Initial), render: renderer });
    };
    return FluorescentHairpinTrackingPage;
}(React.PureComponent));
export default FluorescentHairpinTrackingPage;
var FluorescentHairpinContent = /** @class */ (function (_super) {
    __extends(FluorescentHairpinContent, _super);
    function FluorescentHairpinContent(props) {
        var _this = _super.call(this, props) || this;
        _this.renderTable = function (resp) {
            return React.createElement(Table, { striped: true, celled: true },
                React.createElement(Table.Header, null,
                    React.createElement(Table.Row, null,
                        React.createElement(Table.HeaderCell, null),
                        React.createElement(Table.HeaderCell, null, "H1 50\u00B5L aliquots"),
                        React.createElement(Table.HeaderCell, null, "H2 50\u00B5L aliquots"),
                        React.createElement(Table.HeaderCell, null, "H1 200\u00B5L aliquots"),
                        React.createElement(Table.HeaderCell, null, "H2 200\u00B5L aliquots"),
                        React.createElement(Table.HeaderCell, null, "H1 334\u00B5L aliquots"),
                        React.createElement(Table.HeaderCell, null, "H2 334\u00B5L aliquots"))),
                React.createElement(Table.Body, null, resp.fluorescentHairpins.map(function (entry, index) {
                    return React.createElement(Table.Row, { key: index },
                        React.createElement(Table.Cell, null,
                            entry.hcrAmplifier.id,
                            "-",
                            entry.label.name,
                            " ",
                            _this.editFluorescentHairpinEntry(entry, _this.props.catalog)),
                        React.createElement(Table.Cell, null, entry.h1Aliquots50Ul),
                        React.createElement(Table.Cell, null, entry.h2Aliquots50Ul),
                        React.createElement(Table.Cell, null, entry.h1Aliquots200Ul),
                        React.createElement(Table.Cell, null, entry.h2Aliquots200Ul),
                        React.createElement(Table.Cell, null, entry.h1Aliquots334Ul),
                        React.createElement(Table.Cell, null, entry.h2Aliquots334Ul));
                })));
        };
        _this.renderEventsTable = function (resp) {
            return React.createElement(React.Fragment, null,
                React.createElement(Header, null, "Events"),
                React.createElement(ReactTable, { columns: [
                        {
                            id: 'name',
                            Header: 'User',
                            accessor: function (e) { return e.user.name; }
                        },
                        {
                            id: 'type',
                            Header: 'Type',
                            accessor: function (e) { return e.type; }
                        },
                        {
                            id: 'hcrAmplifier',
                            Header: 'Amplifier',
                            accessor: function (e) { return e.hcrAmplifier.id; }
                        },
                        {
                            id: 'label',
                            Header: 'Label',
                            accessor: function (e) { return e.label.name; }
                        },
                        {
                            id: 'msg',
                            Header: 'Message',
                            accessor: function (e) { return e.msg; },
                            Cell: function (props) { return React.createElement("span", { title: props.value }, props.value); }
                        },
                        {
                            id: 'createdAt',
                            Header: 'Created',
                            accessor: function (e) { return displayLocalTimestamp(e.createdAt); }
                        },
                    ], data: resp.fluorescentHairpinEvents, defaultPageSize: 50, defaultSorted: [{
                            id: 'createdAt'
                        }], minRows: 1 }));
        };
        _this.loadData = function () {
            _this.setState({ loading: true }, function () {
                getWithAuthn('/admin/inventory/fluorescent-hairpins')
                    .then(function (resp) {
                    if (resp.ok) {
                        return resp.json();
                    }
                    else {
                        return undefined;
                    }
                })
                    .then(function (resp) {
                    if (resp === undefined) {
                        _this.setState({
                            loading: false,
                            error: true
                        });
                    }
                    else {
                        _this.setState({
                            error: false,
                            loading: false,
                            response: resp
                        });
                    }
                })
                    .catch(function (rej) {
                    console.error("Couldn't load report: " + rej);
                });
            });
        };
        _this.inputNewAliquots = function (catalog) {
            var renderFluorescentHairpinModal = function (props) {
                return React.createElement(FluorescentHairpinModal, __assign({ catalog: catalog }, props));
            };
            return React.createElement(Modal, { closeIcon: true, onClose: _this.loadData, trigger: React.createElement(Button, { icon: 'plus', labelPosition: 'left', label: 'Input new aliquots' }) },
                React.createElement(Modal.Header, null, "Input new aliquots"),
                React.createElement(Modal.Content, null,
                    React.createElement(SimpleFormWithErrorDisplay, { render: renderFluorescentHairpinModal, successMessage: 'New aliquots inputted' })));
        };
        _this.editFluorescentHairpinEntry = function (fluorescentHairpinEntry, catalog) {
            var renderFluorescentHairpinModal = function (props) {
                return React.createElement(FluorescentHairpinModal, __assign({ fluorescentHairpinEntry: fluorescentHairpinEntry, catalog: catalog }, props));
            };
            return React.createElement(Modal, { closeIcon: true, onClose: _this.loadData, trigger: React.createElement(Button, { icon: 'edit', size: 'mini' }) },
                React.createElement(Modal.Header, null, "Edit fluorescent hairpin inventory"),
                React.createElement(Modal.Content, null,
                    React.createElement(SimpleFormWithErrorDisplay, { render: renderFluorescentHairpinModal, successMessage: 'Inventory updated' })));
        };
        _this.uploadInventory = function () {
            return React.createElement(Modal, { closeIcon: true, onClose: _this.loadData, trigger: React.createElement(Button, { icon: 'plus', labelPosition: 'left', label: 'Upload inventory' }) },
                React.createElement(Modal.Header, null, "Upload inventory"),
                React.createElement(Modal.Content, null,
                    React.createElement(UploadFileModal, { path: "/admin/inventory/fluorescent-hairpins/upload-current-inventory" })));
        };
        _this.state = {
            loading: false,
            error: false
        };
        return _this;
    }
    FluorescentHairpinContent.prototype.render = function () {
        return React.createElement(Dimmer.Dimmable, { className: 'non-header-portion' },
            React.createElement(Dimmer, { active: this.state.loading, inverted: true },
                React.createElement(Loader, null)),
            this.state.error &&
                React.createElement(Message, { negative: true }, "Report could not be loaded."),
            React.createElement(Menu, null,
                React.createElement(Menu.Item, null, this.uploadInventory()),
                React.createElement(Menu.Item, null, this.inputNewAliquots(this.props.catalog))),
            this.state.response && this.renderTable(this.state.response),
            this.state.response && this.renderEventsTable(this.state.response));
    };
    FluorescentHairpinContent.prototype.componentDidMount = function () {
        this.loadData();
    };
    return FluorescentHairpinContent;
}(React.PureComponent));
var FluorescentHairpinModal = /** @class */ (function (_super) {
    __extends(FluorescentHairpinModal, _super);
    function FluorescentHairpinModal(props) {
        var _this = _super.call(this, props) || this;
        _this.onH1LotNumberChange = function (_, data) {
            var str = data.value;
            _this.setState({ h1LotNumber: str });
        };
        _this.onH2LotNumberChange = function (_, data) {
            var str = data.value;
            _this.setState({ h2LotNumber: str });
        };
        _this.onAmplifierChange = function (_, data) {
            var valStr = data.value;
            var catalog = Array.from(new Set(__spreadArrays(_this.props.catalog.rnaCatalog.legacyFishAmplifier.channels, _this.props.catalog.rnaCatalog.goldFishAmplifier.channels))).find(function (a) {
                return a.hcrAmplifier.id === valStr;
            });
            if (catalog === undefined) {
                throw new RangeError("Invalid amplifier " + valStr);
            }
            _this.setState({
                hcrAmplifier: catalog.hcrAmplifier
            });
        };
        _this.onLabelChange = function (_, data) {
            var val = data.value;
            var catalog = Array.from(new Set(__spreadArrays(_this.props.catalog.rnaCatalog.legacyFishAmplifier.channels, _this.props.catalog.rnaCatalog.goldFishAmplifier.channels)));
            var currentAmpCatalog = catalog.find(function (c) {
                return c.hcrAmplifier.id === _this.state.hcrAmplifier.id;
            });
            if (currentAmpCatalog == null) {
                throw new Error("Unexpected amplifier value type: " + _this.state.hcrAmplifier.id);
            }
            var newLabel = currentAmpCatalog.labels.combined.concat(currentAmpCatalog.labels.admin)
                .find(function (l) { return l.label.id === val; });
            if (newLabel === undefined) {
                throw new RangeError("Unknown label value " + val);
            }
            _this.setState({
                label: newLabel.label
            });
        };
        _this.onH1Aliquots50UlChange = function (_, data) {
            var str = data.value;
            var num = parseInt(str, 10);
            if (isNaN(num)) {
                // no op -- discard input
                return;
            }
            _this.setState({ h1Aliquots50Ul: num });
        };
        _this.onH2Aliquots50UlChange = function (_, data) {
            var str = data.value;
            var num = parseInt(str, 10);
            if (isNaN(num)) {
                // no op -- discard input
                return;
            }
            _this.setState({ h2Aliquots50Ul: num });
        };
        _this.onH1Aliquots200UlChange = function (_, data) {
            var str = data.value;
            var num = parseInt(str, 10);
            if (isNaN(num)) {
                // no op -- discard input
                return;
            }
            _this.setState({ h1Aliquots200Ul: num });
        };
        _this.onH2Aliquots200UlChange = function (_, data) {
            var str = data.value;
            var num = parseInt(str, 10);
            if (isNaN(num)) {
                // no op -- discard input
                return;
            }
            _this.setState({ h2Aliquots200Ul: num });
        };
        _this.onH1Aliquots334UlChange = function (_, data) {
            var str = data.value;
            var num = parseInt(str, 10);
            if (isNaN(num)) {
                // no op -- discard input
                return;
            }
            _this.setState({ h1Aliquots334Ul: num });
        };
        _this.onH2Aliquots334UlChange = function (_, data) {
            var str = data.value;
            var num = parseInt(str, 10);
            if (isNaN(num)) {
                // no op -- discard input
                return;
            }
            _this.setState({ h2Aliquots334Ul: num });
        };
        _this.submit = function () {
            if (_this.props.fluorescentHairpinEntry == null) {
                _this.props.postRequest("/admin/inventory/fluorescent-hairpins/add-new-aliquots", {
                    h1LotNumber: _this.state.h1LotNumber,
                    h2LotNumber: _this.state.h2LotNumber,
                    hcrAmplifierId: _this.state.hcrAmplifier.id,
                    label: {
                        '_type': 'predefined',
                        id: _this.state.label.id
                    },
                    h1Aliquots50Ul: _this.state.h1Aliquots50Ul,
                    h2Aliquots50Ul: _this.state.h2Aliquots50Ul,
                    h1Aliquots200Ul: _this.state.h1Aliquots200Ul,
                    h2Aliquots200Ul: _this.state.h2Aliquots200Ul,
                    h1Aliquots334Ul: _this.state.h1Aliquots334Ul,
                    h2Aliquots334Ul: _this.state.h2Aliquots334Ul
                });
            }
            else {
                _this.props.postRequest("/admin/inventory/fluorescent-hairpins/update-existing-entry/id/" + encodeURIComponent(_this.props.fluorescentHairpinEntry.id), {
                    h1Aliquots50Ul: _this.props.fluorescentHairpinEntry.h1Aliquots50Ul === _this.state.h1Aliquots50Ul ? null : _this.state.h1Aliquots50Ul,
                    h2Aliquots50Ul: _this.props.fluorescentHairpinEntry.h2Aliquots50Ul === _this.state.h2Aliquots50Ul ? null : _this.state.h2Aliquots50Ul,
                    h1Aliquots200Ul: _this.props.fluorescentHairpinEntry.h1Aliquots200Ul === _this.state.h1Aliquots200Ul ? null : _this.state.h1Aliquots200Ul,
                    h2Aliquots200Ul: _this.props.fluorescentHairpinEntry.h2Aliquots200Ul === _this.state.h2Aliquots200Ul ? null : _this.state.h2Aliquots200Ul,
                    h1Aliquots334Ul: _this.props.fluorescentHairpinEntry.h1Aliquots334Ul === _this.state.h1Aliquots334Ul ? null : _this.state.h1Aliquots334Ul,
                    h2Aliquots334Ul: _this.props.fluorescentHairpinEntry.h2Aliquots334Ul === _this.state.h2Aliquots334Ul ? null : _this.state.h2Aliquots334Ul
                });
            }
        };
        _this.state = {
            h1LotNumber: "",
            h2LotNumber: "",
            hcrAmplifier: props.fluorescentHairpinEntry ? props.fluorescentHairpinEntry.hcrAmplifier : props.catalog.rnaCatalog.legacyFishAmplifier.defaultChannel.hcrAmplifier,
            label: props.fluorescentHairpinEntry ? props.fluorescentHairpinEntry.label : props.catalog.rnaCatalog.legacyFishAmplifier.defaultChannel.defaultLabel.label,
            h1Aliquots50Ul: props.fluorescentHairpinEntry ? props.fluorescentHairpinEntry.h1Aliquots50Ul : 0,
            h2Aliquots50Ul: props.fluorescentHairpinEntry ? props.fluorescentHairpinEntry.h2Aliquots50Ul : 0,
            h1Aliquots200Ul: props.fluorescentHairpinEntry ? props.fluorescentHairpinEntry.h1Aliquots200Ul : 0,
            h2Aliquots200Ul: props.fluorescentHairpinEntry ? props.fluorescentHairpinEntry.h2Aliquots200Ul : 0,
            h1Aliquots334Ul: props.fluorescentHairpinEntry ? props.fluorescentHairpinEntry.h1Aliquots334Ul : 0,
            h2Aliquots334Ul: props.fluorescentHairpinEntry ? props.fluorescentHairpinEntry.h2Aliquots334Ul : 0
        };
        return _this;
    }
    FluorescentHairpinModal.prototype.render = function () {
        var _this = this;
        var catalog = Array.from(new Set(__spreadArrays(this.props.catalog.rnaCatalog.legacyFishAmplifier.channels, this.props.catalog.rnaCatalog.goldFishAmplifier.channels)));
        var currentAmpCatalog = catalog.find(function (c) {
            return c.hcrAmplifier.id === _this.state.hcrAmplifier.id;
        });
        if (currentAmpCatalog == null) {
            throw new RangeError("Invalid Amplifier " + this.state.hcrAmplifier.id);
        }
        var labelOptions = currentAmpCatalog === null || currentAmpCatalog === void 0 ? void 0 : currentAmpCatalog.labels.combined.concat(currentAmpCatalog.labels.admin).sort(function (a, b) { return a.label.name.localeCompare(b.label.name); }).map(function (l) { return ({
            // match left spacing from custom icon
            text: React.createElement(React.Fragment, null,
                React.createElement("span", null, l.label.name)),
            content: React.createElement(React.Fragment, null,
                React.createElement("span", null, l.label.name)),
            value: l.label.id
        }); });
        var amplifierDropdownText = function () {
            return catalog.map(function (a) {
                return {
                    text: React.createElement(React.Fragment, null, a.hcrAmplifier.id),
                    value: a.hcrAmplifier.id
                };
            });
        };
        return React.createElement(Grid, { columns: 2 },
            this.props.fluorescentHairpinEntry == null &&
                React.createElement(Grid.Row, null,
                    React.createElement(Grid.Column, null,
                        React.createElement(FieldWithErrorDisplay, { errors: this.props.state.errors, errorPath: '/h1LotNumber', labelContent: 'H1 Lot Number' },
                            React.createElement(Input, { onChange: this.onH1LotNumberChange, placeholder: 'H1 Lot Number', type: "text", value: this.state.h1LotNumber }))),
                    React.createElement(Grid.Column, null,
                        React.createElement(FieldWithErrorDisplay, { errors: this.props.state.errors, errorPath: '/h2LotNumber', labelContent: 'H2 Lot Number' },
                            React.createElement(Input, { onChange: this.onH2LotNumberChange, placeholder: 'H2 Lot Number', type: "text", value: this.state.h2LotNumber })))),
            React.createElement(Grid.Row, null,
                React.createElement(Grid.Column, null,
                    React.createElement(FieldWithErrorDisplay, { errorPath: '/amplifier', errors: this.props.state.errors, labelContent: 'Amplifier' },
                        React.createElement(Select, { className: "label-dropdown", disabled: this.props.fluorescentHairpinEntry != null, value: this.state.hcrAmplifier.id, onChange: this.onAmplifierChange, options: amplifierDropdownText(), name: 'amp-hcr-amplifier' }))),
                React.createElement(Grid.Column, null,
                    React.createElement(FieldWithErrorDisplay, { errorPath: '/label', errors: this.props.state.errors, labelContent: 'Label' },
                        React.createElement(Select, { name: 'amp-label', className: labelOptions.length <= 1 ? "deactivated-dropdown" : "selection-dropdown", disabled: this.props.fluorescentHairpinEntry != null, onChange: this.onLabelChange, options: labelOptions, value: this.state.label.id, search: true, scrolling: false, icon: labelOptions.length <= 1 ? false : undefined })))),
            React.createElement(Grid.Row, null,
                React.createElement(Grid.Column, null,
                    React.createElement(FieldWithErrorDisplay, { errors: this.props.state.errors, errorPath: '/h1Aliquots50Ul', labelContent: 'H1 50µL aliquots' },
                        React.createElement(Input, { onChange: this.onH1Aliquots50UlChange, placeholder: '0', type: "number", value: this.state.h1Aliquots50Ul }))),
                React.createElement(Grid.Column, null,
                    React.createElement(FieldWithErrorDisplay, { errors: this.props.state.errors, errorPath: '/h2Aliquots50Ul', labelContent: 'H2 50µL aliquots' },
                        React.createElement(Input, { onChange: this.onH2Aliquots50UlChange, placeholder: '0', type: "number", value: this.state.h2Aliquots50Ul })))),
            React.createElement(Grid.Row, null,
                React.createElement(Grid.Column, null,
                    React.createElement(FieldWithErrorDisplay, { errors: this.props.state.errors, errorPath: '/h1Aliquots200Ul', labelContent: 'H1 200µL aliquots' },
                        React.createElement(Input, { onChange: this.onH1Aliquots200UlChange, placeholder: '0', type: "number", value: this.state.h1Aliquots200Ul }))),
                React.createElement(Grid.Column, null,
                    React.createElement(FieldWithErrorDisplay, { errors: this.props.state.errors, errorPath: '/h2Aliquots200Ul', labelContent: 'H2 200µL aliquots' },
                        React.createElement(Input, { onChange: this.onH2Aliquots200UlChange, placeholder: '0', type: "number", value: this.state.h2Aliquots200Ul })))),
            React.createElement(Grid.Row, null,
                React.createElement(Grid.Column, null,
                    React.createElement(FieldWithErrorDisplay, { errors: this.props.state.errors, errorPath: '/h1Aliquots334Ul', labelContent: 'H1 334µL aliquots' },
                        React.createElement(Input, { onChange: this.onH1Aliquots334UlChange, placeholder: '0', type: "number", value: this.state.h1Aliquots334Ul }))),
                React.createElement(Grid.Column, null,
                    React.createElement(FieldWithErrorDisplay, { errors: this.props.state.errors, errorPath: '/h2Aliquots334Ul', labelContent: 'H2 334µL aliquots' },
                        React.createElement(Input, { onChange: this.onH2Aliquots334UlChange, placeholder: '0', type: "number", value: this.state.h2Aliquots334Ul })))),
            React.createElement(Grid.Row, null,
                React.createElement(Grid.Column, null,
                    React.createElement(Button, { disabled: this.props.state.loading || this.props.state.success, icon: 'plus', label: this.props.fluorescentHairpinEntry ? 'Save update' : 'Add new fluorescent hairpin aliquots', labelPosition: 'left', onClick: this.submit, positive: true }))));
    };
    return FluorescentHairpinModal;
}(React.PureComponent));
//# sourceMappingURL=FluorescentHairpinTrackingPage.js.map


//////////////////
// WEBPACK FOOTER
// ../common/build/dist/admin/FluorescentHairpinTrackingPage.js
// module id = 1472
// module chunks = 0